<template>
  <div style="height: 400px">
    <TlEcharts v-model="state.option" />
  </div>
</template>
<script setup>
import TlEcharts from "@/components/TlEcharts/index.vue";
const formData = defineModel();
onMounted(() => {
  if (formData.value.type === "xt") {
    console.log("血糖");
    state.value.option.yAxis.name = "(mmol/L)";
  } else {
    console.log("血压");
    state.value.option.yAxis.name = "(mmHg)";
  }
  state.value.option =
    formData.value.option != null ? formData.value.option : state.value.option;
});
const state = ref({
  option: {
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: [
        "2024-01",
        "2024-02",
        "2024-03",
        "2024-04",
        "2024-05",
        "2024-06",
        "2024-07"
      ]
    },
    yAxis: {
      type: "value",
      name: "血压值mmHg",
      position: "lief",
      nameTextStyle: {
        align: "center"
      },
      alignTicks: true,
      nameLocation: "end"
    },
    series: [
      {
        name: "收缩压",
        type: "line",
        data: [120, 132, 101, 134, 90, 230, 210]
      },
      {
        name: "舒张压",
        type: "line",
        data: [220, 182, 191, 234, 290, 330, 310]
      }
    ]
  }
});
</script>
<style scoped lang="scss"></style>
